module.exports = __webpack_public_path__ + "img/background.8b5dca70.jpg";